import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "bg-grey-lighten-4 rounded p-3",
  "data-cy": "agent-identity"
}
const _hoisted_2 = { class: "font-weight-medium" }
const _hoisted_3 = { class: "text-caption text-grey-darken-1 mt-1" }
const _hoisted_4 = { class: "mt-2" }
const _hoisted_5 = {
  key: 0,
  class: "text-caption text-amber-darken-4 mt-2 mb-0",
  "data-cy": "unverified-warning"
}
const _hoisted_6 = {
  key: 1,
  class: "mt-2",
  "data-cy": "agent-redirect-uris"
}
const _hoisted_7 = { class: "ml-4 mb-0 text-caption" }
const _hoisted_8 = {
  key: 2,
  class: "text-caption text-grey-darken-1 mt-2 mb-0",
  "data-cy": "copilot-studio-note"
}

import { computed } from 'vue';
import LlStatusBadge from '@/components/LlStatusBadge.vue';
import { COPILOT_STUDIO_CLIENT_ID, type AgentAccessAgent } from '../models/agentAccessTypes';

// For a verified agent LeanLaw established both the name and the address. For an unverified one the
// registrant typed both, which is why the warning says so rather than pointing at the address.

export default /*@__PURE__*/_defineComponent({
  __name: 'AgentIdentity',
  props: {
    agent: {}
  },
  setup(__props: any) {

const props = __props;

const isCopilotStudio = computed(() => props.agent.clientId === COPILOT_STUDIO_CLIENT_ID);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.agent.name), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(__props.agent.origin), 1),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(LlStatusBadge, {
        tone: __props.agent.isVerifiedPublisher ? 'green' : 'amber'
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.agent.isVerifiedPublisher ? 'Verified' : 'Unverified'), 1)
        ]),
        _: 1
      }, 8, ["tone"])
    ]),
    (!__props.agent.isVerifiedPublisher)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, " LeanLaw has not verified this agent. Its name and address were chosen by whoever registered it, so it can claim to be anyone. Approve it only if you know where it came from. "))
      : _createCommentVNode("", true),
    (__props.agent.redirectUris?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-caption text-grey-darken-1" }, "It can send people's approvals to:", -1)),
          _createElementVNode("ul", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.agent.redirectUris, (uri) => {
              return (_openBlock(), _createElementBlock("li", {
                key: uri,
                class: "text-break"
              }, _toDisplayString(uri), 1))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (isCopilotStudio.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Approving Copilot Studio lets any Copilot Studio connector reach your firm's sign-in screen. Each person still signs in to LeanLaw and approves their own permissions. "))
      : _createCommentVNode("", true)
  ]))
}
}

})